import styled, { css } from 'styled-components'

const TombstoneColours = {
  red: '#db3e34',
  orange: '#f39000',
  green: '#76b729'
}

const Container = styled.div`
  width: 80px;
  height: 120px;
  border: 2px solid black;
  border-radius: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  padding-top: 25px;
  padding-bottom: 12px;
  font-weight: 600;
  line-height: 1;

  ${props =>
    props.colorCoding === 'high' &&
    css`
      background: ${TombstoneColours.red};
      border-color: ${TombstoneColours.red};
    `}
  ${props =>
    props.colorCoding === 'medium' &&
    css`
      background: ${TombstoneColours.orange};
      border-color: ${TombstoneColours.orange};
    `}
  ${props =>
    props.colorCoding === 'low' &&
    css`
      background: ${TombstoneColours.green};
      border-color: ${TombstoneColours.green};
    `}

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    margin: 0.25em 0;
  }
`

const Quantity = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Percentage = styled.div`
  background: white;
  border: 2px solid black;
  border-radius: 45px;
  width: 45px;

  ${props =>
    props.colorCoding &&
    css`
      border-color: ${props.theme.color.monochrome.white};
    `}

  ${props =>
    props.longText &&
    css`
      font-size: ${props.theme.font.size.caption};
    `}
`

export { Container, Quantity, Percentage }
